import { render, staticRenderFns } from "./CRTask.vue?vue&type=template&id=7c45424c&scoped=true"
import script from "./CRTask.vue?vue&type=script&lang=js"
export * from "./CRTask.vue?vue&type=script&lang=js"
import style0 from "./CRTask.vue?vue&type=style&index=0&id=7c45424c&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c45424c",
  null
  
)

export default component.exports